import React, { createContext, useState } from 'react';
import { retrieveLanguage }               from '../helpers/storage';
const { Provider, Consumer }              = createContext();

const ContextStore = ({ comp, apollocon, axioscon }) => {

  const defaultLanguage = retrieveLanguage() === null ? 'es-MX' : retrieveLanguage();
  const serviceApollo   = new apollocon('DEVELOP');
  const serviceAxios    = new axioscon('DEVELOP');

  const [conApollo,         setConApollo]              = useState(serviceApollo);
  const [conAxios,          setConAxios]               = useState(serviceAxios);
  const [language,          setLanguage]               = useState(defaultLanguage);

  const [errors,            setErrors]                 = useState({});
  const [listManagers,      setListManagers]           = useState([]);
  const [optionSelected,    setOptionSelected]         = useState({
    collection:             'wallet',
    viewCollection:         'collection',
    viewCalendar:           'events',
    reportCollection:       'paymentsReceived',
    paymentReceiver:        'direction',
    managers:               'manager',
    viewRanking:            'Colocación'
  });
  const [reportValueSelected, setReportValueSelected] = useState({
    directionSelected: [],
    branchSelected:    [],
    managerSelected:   []
  });
  const [valueSelected, setValueSelected]              = useState({
    walletSelected:     {},
    integrantSelected:  {},
    agreementSelected:  {},
    searchWallet:       '',
    searchAgreement:    '',
    branchWallet:       '',
    managerWallet:      '',
    branchAgreement:    '',
    managerAgreement:   '',
    delayDaysWallet:    '',
    delayDaysAgreement: '',
    statusAgreement:    '',
    manager:            '',
    branchOffice:       '',
    wallet:             '',
    isagreeGroup:       '',
    infoDocumentAgree:  '',
    typeAgreement:      ''
  });
  const [catalogs,       setCatalogs]       = useState({
    banchOffice:        [],
    managers:           [],
    daysDelay:          [],
    daysDelayTwo:       [],
    statusAgreement:    [],
    groupAgreement:     [],
    banchOfficeUser:    [],
    payments:           []
});
  const [isToolbar,         setIsToolbar]              = useState(false);
  const [isMobile,          setIsMobile]               = useState(false);
  const [pagination,        setPagination]             = useState({
    pageWallet:           1,
    totalPagesWallet:     0,
    totalWallet:          0,
    pageAgreements:       1,
    totalPagesAgreements: 0,
    totalAgreements:      0
  });
  const [isLoading,         setIsLoading]              = useState({
    wallet:                    true,
    agreements:                true,
    detailAgreements:          true,
    amortizations:             true,
    tableAmortization:         false,
    endorsements:              true,
    integrants:                true,
    documents:                 true,
    paymentHistory:            true,
    informationGeneral:        true,
    verificationGeneral:       true,
    paymentHistoryA:           true,
    integrantsA:               true,
    generatePayPDF:            false,
    generateReferencePartial:  false,
    documentAgreements:        true,
    paymentsReceived:          true,
    managerProgressRecovery:   false,
    managersCollections:       false,
    amortizationAgreement:     false,
    generateManagerReportPDF:  false,
    statamentPayment:          false
  });

  const [dataManagers, setDataManagers]                = useState([]);

  /// General Information (section Integrant)
  const [generalInformation, setGeneralInformation] = useState({
      dateBirday:    '-',
      age:           '-',
      cityBirday:    '-',
      stateBirday:   '-',
      countryBirday: '-',
      nacionality:   '-',
      rfc:           '-',
      curp:          '-',
      noINE:         '-',
      gender:        '-',
      scolarShip:    '-',
      maritalStatus: '-',
      dependents:    '-',
      phoneHome:     '-',
      phoneErrand:   '-',
      cellPhone:     '-',
      email:         '-',
      streetAdress:         '-',
      exteriorAdress:       '-',
      interiorAdress:       '-',
      neighborhoodAdress:   '-',
      cityAdress:           '-',
      municipalityAdress:   '-',
      statesAdress:         '-',
      countryAdress:        '-',
      codePostalAdress:     '-',
      yearsAdress:          '-',
      monthsAdress:         '-',
      typeHousing:          '-',
      populationArea:       '-',
      water:                false,
      light:                false,
      drainage:             false,
      phone:                false,
      betweenStreets:       '-',
      nameBunisess:            '-',
      turnBunisess:            '-',
      activityBunisess:        '-',
      homeBunisess:            '-',
      streetBunisess:          '-',
      exteriorBunisess:        '-',
      interiorBunisess:        '-',
      neighborhoodBunisess:    '-',
      municipalityBunisess:    '-',
      stateBunisess:           '-',
      countryBunisess:         '-',
      codePostalBunisess:      '-',
      yearsBunisess:           '-',
      monthsBunisess:          '-',
      localTypeBunisess:       '-',
      populationAreaBunisess:  '-',
      phoneBunisess:           '-',
      numberEmployeBunisess:   '-',
      weeklySalesBunisess:     '-',
      weeklyEarningsBunisess:  '-',
      paymentCapacityBunisess: '-',
      nameSpouse:         '-',
      dateBirdaySpouse:   '-',
      adressSpouse:       '-',
      ageSpouse:          '-',
      occupationSpouse:   '-',
      nameCompanySpouse:  '-',
      phoneCompanySopuse: '-',
      phoneSopuse:        '-',
      itClient:           false,
      whatProductSpouse: '-',
      nameReference0:    '-',
      phonePReference0:  '-',
      phoneReference0:   '-',
      nameReference1:    '-',
      phonePReference1:  '-',
      phoneReference1:   '-',
      nameReference2:    '-',
      phonePReference2:  '-',
      phoneReference2:   '-',
      requestAmount:     '-',
      term:              '-',
      wayToPay:          '-',
      creditDestination: '-',
      proposedAmount:    '-',
      authorizedAmount:  '-',
      nameMetamembred:         '-',
      dateBirdayMetamember:    '-',
      realtionsShipMetamember: '-',
      adressMetamember:        '-',
      phoneMetamember:         '-',
      typeMetamember:          '-',
      maximAmountAllowed:  '-',
      maximOperations:     '-',
      paymentInstrument:   '-',
      otherPaymentInstrument: '-',
      paymentCurrency:     '-',
      prepaid:             '-'
  });

  const [documentsClient, setDocumentsClient] = useState({
      curp:     '',
      IFEfront: '',
      IFEBack:  '',
      adress:   ''
  });

  /// Verification Information (section Integrant)
  const [bunissesInformation, setBunissesInformation] = useState({
    adressFromAdress:       '-',
    typeHousing:            '-',
    waterAdress:            false,
    lightAdress:            false,
    phoneAdress:            false,
    televisionAdress:       false,
    gasAdress:              false,
    othersAdress:           false, 
    contructionHouse:       '-',
    accessConditionsAdress: '-',
    homeSecurityAdress:     '-',
    zoneAdress:             '-',
    publicTransportAdress:  '-',
    commentsAdress:         '-',
    isWarningZone:          false,
    latitudAdress:          0,
    longitudAdress:         0,
    referencesAdress:       '-',
    commentsVery:           '-',
    latitudBusiness:        0,
    longitudBusiness:       0,
    referencesBusiness:     '-',
    adressBusiness:         '-',
    creditDestination:      '-',
    amountBusiness:         '-',
    toolsBusiness:          '-',
    businessType:           '-',
    businessConstruction:   '-',
    accessConditions:       '-',
    homeSecurity:           '-',
    zone:                   '-',
    highRisk:               '-',
    conveyance:             '-',
  });

  const [documentsVerification, setDocumentsVerification] = useState({
      exteriorAdress:  '',
      interiorAdress:  '',
      referenceAdress: '',
      extraAdress:     '',
      albumAdress:     '',
      exteriorBusiness:  '',
      interiorBusiness:  '',
      inventoryBunisess: '',
      referenceBusiness: '',
      extraBusiness:     '',
      extra2Business:    '',
      extra3Business:    '',
      extra4Business:    '',
      extra5Business:    '',
      extra6Business:    ''
  });
  
  const [modal, setModal]                              = useState({
    showModal:  false,
    closeModal: null,
    component:  null,
    customCss:  null,
    size:       'xl',
    backdrop:   null,
  });

  const contextValues = {
    modal,
    setModal,
    conApollo, 
    conAxios,  
    language,
    setLanguage,
    errors,            
    setErrors,
    listManagers,      
    setListManagers,
    optionSelected,    
    setOptionSelected,
    reportValueSelected, 
    setReportValueSelected,
    valueSelected, 
    setValueSelected,
    catalogs,       
    setCatalogs,
    isMobile,          
    setIsMobile,
    pagination,        
    setPagination,
    isToolbar, 
    setIsToolbar,
    isLoading,         
    setIsLoading,
    dataManagers, 
    setDataManagers,
    generalInformation, 
    setGeneralInformation,
    documentsClient, 
    setDocumentsClient,
    bunissesInformation, 
    setBunissesInformation,
    documentsVerification, 
    setDocumentsVerification
  }

  return <Provider value={contextValues}>{comp}</Provider>
}

const WrapperConsumer = (Component) => {
  return (props) => (
    <Consumer>
      {(context) => <Component {...props} context={context} />}
    </Consumer>
  )
}

export default WrapperConsumer
export { ContextStore, Consumer }
